var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#00CC99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1704 37.2392C66.1435 38.0433 66.2805 39.4841 65.4763 40.4571L47.0992 62.6954L47.0937 62.7021C46.6757 63.204 46.151 63.6065 45.558 63.8802C44.9649 64.1539 44.3182 64.292 43.6651 64.2845L43.6631 64.2845C42.9992 64.2762 42.3459 64.1176 41.7521 63.8207C41.1602 63.5248 40.6429 63.0991 40.2386 62.5755C40.2372 62.5737 40.2358 62.5719 40.2345 62.5702L34.4816 55.1736C33.7066 54.1772 33.8861 52.7411 34.8825 51.9661C35.879 51.1911 37.315 51.3706 38.0901 52.3671L43.7211 59.6069L61.9524 37.5451C62.7566 36.572 64.1973 36.435 65.1704 37.2392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.7bddccbb7ab16428b70169f6155e9d6d.svg";
export { ForwardRef as ReactComponent };